import { PartnerSignupPage } from 'components/pages/PartnerSignup'
import { useSelf } from 'components/providers/SelfProvider'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export default function () {
	const router = useRouter()
	const { user, isPartner } = useSelf()

	const partnerSlug = user.partnerSlug

	useEffect(() => {
		if (isPartner && partnerSlug) {
			router.replace(`${partnerSlug}/client-referrals`)
		}
	}, [router, partnerSlug, isPartner])

	return <PartnerSignupPage />
}
